// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorAlert_root__4JsDH","body":"ErrorAlert_body__eFkWu","button":"ErrorAlert_button__hNq5X"};